import { render, staticRenderFns } from "./awards-winner.vue?vue&type=template&id=80e116d2&scoped=true&lang=pug&"
import script from "./awards-winner.vue?vue&type=script&lang=js&"
export * from "./awards-winner.vue?vue&type=script&lang=js&"
import style0 from "./awards-winner.vue?vue&type=style&index=0&id=80e116d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e116d2",
  null
  
)

/* custom blocks */
import block0 from "./awards-winner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsListItem: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/list-item.vue').default})
